import { Box, Typography } from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import CancelModalButton from "../../../UIElements/CustomModal/CancelModalButton";

export default function DeleteDossierModalContent({
    onDeleteDossier,
}: {
    onDeleteDossier: Function;
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "2rem",
                    flex: "1 0 0",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.5rem",
                        flex: "1 0 0",
                        alignSelf: "stretch",
                    }}
                >
                    <Typography
                        sx={{
                            alignSelf: "stretch",
                            color: "#023",
                            fontFamily: "Roboto",
                            fontSize: "1.25rem",
                            fontQtyle: "normal",
                            fontWeight: 700,
                            lineHeight: "normal",
                        }}
                    >
                        Êtes-vous sur de vouloir supprimer ce dossier ?
                    </Typography>
                    <Typography
                        sx={{
                            alignSelf: "stretch",
                            color: "#023",
                            fontFamily: "Roboto",
                            fontSize: "0.875rem",
                            fontQtyle: "normal",
                            fontWeight: 400,
                            lineHeight: "1.25rem",
                        }}
                    >
                        Ce dossier sera définitivement supprimé et vous ne
                        pourrez plus le modifier.
                    </Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "2rem",
                    flex: "1 0 0",
                    width: "100%",
                }}
            >
                <CustomButton
                    onClick={async () => {
                        await onDeleteDossier();
                    }}
                    label="Je supprime le dossier"
                    customsx={{
                        width: "100%",
                    }}
                />
                <CancelModalButton
                    customsx={{
                        width: "100%",
                    }}
                />
            </Box>
        </Box>
    );
}
